export const fonts = {
  body: 'var(--font-inter), system-ui, sans-serif',
  heading: 'var(--font-inter), system-ui, sans-serif',
}

export const textStyles = {
  display: { fontSize: '30px', fontWeight: 700, lineHeight: 1.2, letterSpacing: '-0.02em' },
  h1: { fontSize: '24px', fontWeight: 700, lineHeight: 1.25, letterSpacing: '-0.01em' },
  h2: { fontSize: '20px', fontWeight: 600, lineHeight: 1.3, letterSpacing: '-0.01em' },
  h3: { fontSize: '16px', fontWeight: 600, lineHeight: 1.4, letterSpacing: '0' },
  body: { fontSize: '14px', fontWeight: 400, lineHeight: 1.55, letterSpacing: '0' },
  bodySm: { fontSize: '13px', fontWeight: 400, lineHeight: 1.5, letterSpacing: '0' },
  caption: { fontSize: '12px', fontWeight: 500, lineHeight: 1.4, letterSpacing: '0.01em' },
}
